module.exports = __webpack_public_path__ + "img/banner3_1_zh.9d43848e.png";